import { Component, DOCUMENT, EventEmitter, inject, Input, Output, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PermissionService } from '../../core/services/permission.service';
import { PERMISSION_LIST } from '@/app/core/constants/constants';
import { MODULE_ROUTE_PRIORITY } from '@/app/core/constants/module-route-priority';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly permissionService = inject(PermissionService);
  private readonly router = inject(Router);
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);
  readonly PERMISSIONS = PERMISSION_LIST;
  homeRoute = '/dashboard';
  @Input() isCollapsed = false;

  constructor() {
    this.homeRoute = this.getFirstSidebarRoute();
    // Auto-close Master Data on any navigation
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // this.isMasterDataOpen = false;
      if (this.isMobileOpen) {
        this.closeMobile.emit();
      }
    });
  }
  isMasterDataOpen = false;
  toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;

    if (this.isCollapsed) {
      this.renderer.addClass(this.document.body, 'sidebar-collapsed');
    } else {
      this.renderer.removeClass(this.document.body, 'sidebar-collapsed');
    }
  }
  @Input() isMobileOpen = false;
  @Output() closeMobile = new EventEmitter<void>();

  toggleMasterData(): void {
    // if (this.isCollapsed) return; // prevent dropdown in collapsed mode
    this.isMasterDataOpen = !this.isMasterDataOpen;
  }

  has(permission: string): boolean {
    return this.permissionService.has(permission);
  }

  hasAny(permissions: string[]): boolean {
    return this.permissionService.hasAny(permissions);
  }

  private getFirstSidebarRoute(): string {
    const allowed = MODULE_ROUTE_PRIORITY.find(({ permission }) =>
      this.permissionService.has(permission),
    );
    return allowed?.route ?? '/admin';
  }
}
